import * as s from "./ItemRecorderStyled";
import { COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import { MapSearchData } from "api/interfaces/dashboardInterface.interface";
import RecorderInfoView from "../RecorderInfoView";
import Popover from "antd/lib/popover";

import WebAppLink from "components/blocks/link/WebAppLink";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { useMediaQuery } from "react-responsive";
import { tabletMin } from "components/MediaQuery";
import { ChildrenRecorder } from "./ChildrenRecorder";
import {
  getMarker,
  getTopAlertStatusString,
  RecorderStatus,
} from "../../../utils";
import { AssigneeInfo } from "./AssigneeInfo";

type ItemOneRecorderType = {
  system: MapSearchData;
  onSelectRecorder: (system: MapSearchData) => void;
  cloudStatus: boolean;
};

export const ItemOneRecorder = ({
  system,
  onSelectRecorder,
  cloudStatus,
}: ItemOneRecorderType) => {
  const isNotMobile = useMediaQuery({ minWidth: tabletMin });
  const theme = useAppSelector((state) => state.theme.theme);
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const tmpStatus: RecorderStatus = getTopAlertStatusString(system);
  const isSpectrum = system.displayType === "Spectrum";

  return (
    <Popover
      trigger="hover"
      placement="right"
      content={
        isNotMobile && (
          <RecorderInfoView system={system} cloudStatus={cloudStatus} />
        )
      }
      style={{
        padding: 0,
      }}
      zIndex={980}
      color={
        theme === "light" ? LIGHT_THEME_COLORS.FILTERITEM : COLORS.PRIMARY1
      }
    >
      <s.Item
        key={`recorder-list-map-view-${system.recorderId}`}
        onClick={() => onSelectRecorder(system)}
        isNoMerged={!isSpectrum}
        data-testid="dashboard-map-list-info-item-item-select-recorder"
      >
        <div className="left-info">
          <div className="system-alert-marker">
            <img src={getMarker(tmpStatus)} alt={`marker-${tmpStatus}`} />
          </div>

          <div className="system-info">
            <div className="system-title">
              <h5>{system.mergedSystemName}</h5>
              <div className="web-app-link-wrapper">
                <WebAppLink
                  {...system}
                  accountId={selectedAccount.accountId}
                  cloudStatus={cloudStatus}
                />
              </div>
            </div>

            {isSpectrum ? (
              <ul className="spectrum-system-ul">
                <ChildrenRecorder
                  rec={system}
                  onSelectRecorder={onSelectRecorder}
                />
              </ul>
            ) : (
              <div>
                <AssigneeInfo recorder={system} />
              </div>
            )}
          </div>
        </div>
      </s.Item>
    </Popover>
  );
};
